import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=9e489436&scoped=true"
import script from "./complaint.vue?vue&type=script&lang=js"
export * from "./complaint.vue?vue&type=script&lang=js"
import style0 from "./complaint.vue?vue&type=style&index=0&id=9e489436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e489436",
  null
  
)

export default component.exports